import { IMapConfiguration } from "libraries/interfaces/IMapConfiguration";
import { MapProvider } from "libraries/interfaces/MapProvider";

export interface IGoogleMapsConfiguration extends IMapConfiguration {
    provider: MapProvider.GoogleMaps;
    apiKey: string;
    mapStyle: GoogleMapsStyle;
}

export enum GoogleMapsStyle {
    Roadmap = 'roadmap',
    Satellite = 'satellite',
    Terrain = 'terrain',
    Hybrid = 'hybrid',
}
